import { styled } from "simplydo/react/styled";

import { Image } from "../image";

const ImageDimmer = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
`;

const StyledCardImage = styled.div`
  width: 100%;
  height: 100px;
  position: relative;

  background-color: ${({ theme }) => theme.colors.secondary.solid};

  &,
  > ${Image}, > ${ImageDimmer} {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }

  > ${Image} {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    object-fit: cover;
    object-position: center center;
  }

  > * {
    z-index: 1;
  }
`;

type CardImageComponentProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  dimmed?: boolean;
};

const CardImageComponent = ({
  children,
  style,
  className,
  dimmed,
}: CardImageComponentProps) => {
  return (
    <StyledCardImage style={style} className={className}>
      {dimmed ? <ImageDimmer /> : null}
      {children}
    </StyledCardImage>
  );
};

export const CardImage = styled(CardImageComponent)``;
